export default __webpack_public_path__ + "static/media/ee2a19d3b5c7ee0b63bf27aa6a2776af.svg";